export const SPECIAL_COMPONENTS = [
  { icon: "fas fa-cube", name: "abi_card" },
  { icon: "fas fa-cube", name: "abi_tiles" },
  { icon: "fas fa-cube", name: "abi_content_tabs" },
  { icon: "fas fa-cube", name: "abi_image_slide" },
  { icon: "fas fa-cube", name: "abi_image_slider" },
  { icon: "fas fa-cube", name: "abi_x_col_block" },
  { icon: "fas fa-cube", name: "abi_instagram_post" },
  { icon: "fas fa-cube", name: "abi_card_slider" },
  { icon: "fas fa-cube", name: "abi_header_banner_text" },
  { icon: "fas fa-cube", name: "abi_header_banner_mobile" },
  { icon: "fas fa-cube", name: "abi_hero_review_slider" },
  { icon: "fas fa-cube", name: "abi_content_block_w_summary" },
  { icon: "fas fa-cube", name: "abi_coloured_block" },
  { icon: "fas fa-cube", name: "abi_content_block_wrapper" },
  { icon: "fas fa-cube", name: "abi_grid" },
  { icon: "fas fa-cube", name: "abi_card_tab" },
  { icon: "fas fa-cube", name: "abi_custom_cards" },
  { icon: "fas fa-cube", name: "abi_lined_icons_text" }
];

export const PAGES = [
  {
    icon: "fas fa-bars",
    name: "Category Page",
    url: "/component/category-page"
  },
  {
    icon: "fas fa-bars",
    name: "Post/Page Instance",
    url: "/component/blog-page"
  }
];

export const NOTICE = [
  {
    icon: "fas fa-bars",
    name: "Email Delay Message",
    url: "/component/email-delay-message"
  }
];

export const FAQ_ATTRIBUTES = {
  basic_attributes: ["abi_cf_cols", "abi_cbw_class"],
  dynamic_attributes: ["abi_cf_question", "abi_cf_answer"]
};

export const WRAPPER_ATTRIBUTES = {
  basic_attributes: ["abi_cbw_cols"],
  dynamic_attributes: ["abi_cbw_name", "abi_cbw_components"]
};

export const TILES_ATTRIBUTES = {
  basic_attributes: [
    "abi_t_cols",
    "abi_t_align",
    "abi_t_has_block_title",
    "abi_t_block_title",
    "abi_t_has_border",
    "abi_t_image_type",
    "abi_t_text_style",
    "abi_t_class",
    "abi_t_title_type",
    "abi_t_background",
    "abi_t_button_icon"
  ],
  dynamic_attributes: [
    "abi_t_title",
    "abi_t_text",
    "abi_t_img",
    "abi_t_has_button",
    "abi_t_button_type",
    "abi_t_link",
    "abi_t_button_text",
    "abi_t_button_num",
    "abi_t_button_class",
    "abi_t_sec_button_type",
    "abi_t_sec_link",
    "abi_t_sec_button_text",
    "abi_t_has_input",
    "abi_t_input_id",
    "abi_t_input_label"
  ]
};

export const GRID_ATTRIBUTES = {
  basic_attributes: [
    "abi_grid_align",
    "abi_grid_button_icon",
    "abi_grid_class",
    "abi_grid_title_type",
    "abi_grid_cols",
    "abi_grid_width"
  ],
  dynamic_attributes: [
    "abi_grid_button_link",
    "abi_grid_button_text",
    "abi_grid_button_type",
    "abi_grid_has_button",
    "abi_grid_icon",
    "abi_grid_img",
    "abi_grid_img_full_width",
    "abi_grid_overlay",
    "abi_grid_text",
    "abi_grid_title"
  ]
};

export const TABS_ATTRIBUTES = {
  basic_attributes: [
    "abi_ct_total_cols",
    "abi_ct_justify",
    "abi_ct_heading",
    "abi_ct_heading_content",
    "abi_ct_class"
  ],
  dynamic_attributes: ["abi_ct_body", "abi_ct_item"]
};

export const BLOCKS_ATTRIBUTES = {
  basic_attributes: [
    "abi_cb_image_type",
    "abi_cb_title",
    "abi_cb_id",
    "abi_cb_image",
    "abi_cb_reverse_row",
    "abi_cb_title_type",
    "abi_cb_content_position",
    "abi_cb_img_to_edge",
    "abi_cb_class",
    "abi_cb_summary_type",
    "abi_cb_summary_total_cols",
    "abi_cb_bgcolor",
    "abi_cb_summary_bg"
  ],
  list_attributes: [
    "abi_cb_summary_icon",
    "abi_cb_summary_text",
    "abi_cb_summary_tick"
  ],
  text_attributes: ["abi_cb_body"]
};

export const BLOCKS_WITH_SUMMARY_ATTRIBUTES = {
  basic_attributes: [
    "abi_cb_bgcolor",
    "abi_cb_button_icon",
    "abi_cb_button_link",
    "abi_cb_button_target",
    "abi_cb_button_title",
    "abi_cb_button_type",
    "abi_cb_class",
    "abi_cb_content_position",
    "abi_cb_has_button",
    "abi_cb_id",
    "abi_cb_image",
    "abi_cb_image_type",
    "abi_cb_img_to_edge",
    "abi_cb_reverse_row",
    "abi_cb_summary_bg",
    "abi_cb_summary_total_cols",
    "abi_cb_summary_type",
    "abi_cb_title",
    "abi_cb_title_type"
  ],
  list_attributes: [
    "abi_cb_summary_icon",
    "abi_cb_summary_text",
    "abi_cb_summary_tick"
  ],
  text_attributes: ["abi_cb_body"]
};

export const COLOURED_BLOCKS_ATTRIBUTES = {
  basic_attributes: [
    "abi_cws_bgcolor",
    "abi_cws_button_icon",
    "abi_cws_button_link",
    "abi_cws_button_target",
    "abi_cws_button_title",
    "abi_cws_button_type",
    "abi_cws_class",
    "abi_cws_has_button",
    "abi_cws_icon",
    "abi_cws_id",
    "abi_cws_tip",
    "abi_cws_summary_total_cols",
    "abi_cws_summary_type",
    "abi_cws_summary_title",
    "abi_cws_summary_bg",
    "abi_cws_title",
    "abi_cws_text",
    "abi_cws_add_text"
  ],
  list_attributes: [
    "abi_cws_summary_icon",
    "abi_cws_summary_text",
    "abi_cws_summary_tick"
  ],
  text_attributes: ["abi_cws_summary_body"]
};

export const CARD_ATTRIBUTES = {
  basic_attributes: [
    "abi_card_cols",
    "abi_card_has_heading",
    "abi_card_heading_text",
    "abi_card_has_tag",
    "abi_card_has_block",
    "abi_card_block_text",
    "abi_card_block_link",
    "abi_card_has_button",
    "abi_card_button_type",
    "abi_card_class",
    "abi_card_image_only",
    "abi_card_bg_class"
  ],
  dynamic_attributes: [
    "abi_card_title",
    "abi_card_desc",
    "abi_card_img",
    "abi_card_link",
    "abi_card_button_text",
    "abi_card_tag_text"
  ]
};

export const HERO_REVIEW_ATTRIBUTES = {
  basic_attributes: ["abi_hrs_cols", "abi_hrs_class", "abi_hrs_is_product"],
  dynamic_attributes: [
    "abi_hrs_id",
    "abi_hrs_desc",
    "abi_hrs_name",
    "abi_hrs_title",
    "abi_hrs_star"
  ]
};

export const CARD_SLIDER_ATTRIBUTES = {
  basic_attributes: [
    "abi_cs_block_link",
    "abi_cs_block_text",
    "abi_cs_button_type",
    "abi_cs_class",
    "abi_cs_cols",
    "abi_cs_has_block",
    "abi_cs_has_button",
    "abi_cs_has_heading",
    "abi_cs_has_tag",
    "abi_cs_heading_text"
  ],
  dynamic_attributes: [
    "abi_cs_button_text",
    "abi_cs_desc",
    "abi_cs_img",
    "abi_cs_link",
    "abi_cs_tag_text",
    "abi_cs_title"
  ]
};

export const CARD_TABS_ATTRIBUTES = {
  basic_attributes: [
    "abi_c_cols",
    "abi_c_has_heading",
    "abi_c_heading_text",
    "abi_c_has_tag",
    "abi_c_has_block",
    "abi_c_block_text",
    "abi_c_block_link",
    "abi_c_has_button",
    "abi_c_button_type",
    "abi_c_class",
    "abi_c_bg_class",
    "abi_c_image_only",
    "abi_c_drop_shadow",
    "abi_c_border_radius"
  ],
  dynamic_attributes: [
    "abi_c_title",
    "abi_c_desc",
    "abi_c_img",
    "abi_c_link",
    "abi_c_toggle_target",
    "abi_c_button_text",
    "abi_c_tag_text"
  ]
};

export const CUSTOM_CARDS_ATTRIBUTES = {
  basic_attributes: ["abi_cc_cols"],
  dynamic_attributes: [
    "abi_cc_title",
    "abi_cc_image",
    "abi_cc_body",
    "abi_cc_amount_raised",
    "abi_cc_bgcolor",
    "abi_cc_layout",
    "abi_cc_image_side"
  ]
};

export const LINED_ICONS_TEXT_ATTRIBUTES = {
  basic_attributes: ["abi_li_cols", "abi_li_bgcolor"],
  dynamic_attributes: ["abi_li_icon", "abi_li_text"]
};

export const BANNER_ATTRIBUTES = {
  basic_attributes: ["abi_hb_cols", "abi_hb_display_multiple_banner"],
  dynamic_attributes: ["abi_hb_text"]
};

export const BANNER_MOBILE_ATTRIBUTES = {
  basic_attributes: ["abi_hb_mobile_cols", "abi_hb_display_mobile_banner"],
  dynamic_attributes: ["abi_hb_mobile_text"]
};

export const INSTAGRAM_POST_ATTRIBUTES = {
  basic_attributes: ["abi_ip_cols", "abi_ip_align", "abi_ip_class"],
  dynamic_attributes: ["abi_ip_post_id", "abi_ip_post_caption"]
};
